var $lqx = (function () {
    'use strict';

    /**
     * core.ts - Common functions for $lqx library
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    // Working variables
    const vars = {};
    // Configuration
    const cfg = {};

    /**
     * module.dist.ts - my first module
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2018 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //Declare other variables as needed
    const navigation = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.navigation) === null || _a === void 0 ? void 0 : _a.init)
                return; // Change the module name
            vars.navigation = {
                init: false,
                //Add working variables as needed
            };
            // Default module configuration
            cfg.navigation = {
                enabled: true
                //Add default configuration as needed
            };
            if (customCfg)
                cfg.navigation = jQuery.extend(true, cfg.navigation, customCfg);
            // Initialize only if enabled
            if (cfg.navigation.enabled) { // Change the module name
                lqx.log('Initializing navigation'); // Change the module name
                /**
                 *
                 * Place here logic that needs to be executed
                 * when the module is first initialized
                 *
                 */
                toggleMobileNavigation();
                careersFormLinkXS();
                stickyHeader();
            }
            // Run only once
            vars.navigation.init = true; // Change the module name
        };
        /**
         *
         * Add other functions, constants and variables as needed by the module
         *
         */
        const toggleMobileNavigation = function () {
            document.querySelectorAll('#menu-toggle').forEach(function (element) {
                element.addEventListener('click', function () {
                    const header = document.querySelector('header');
                    if (header !== null) {
                        header.classList.toggle('menu-open');
                        document.body.classList.toggle('nav-menu-open');
                    }
                });
            });
        };
        const careersFormLinkXS = function () {
            if (jQuery('.panel-careers-page-form').length) {
                const target = jQuery('.panel-careers-page-form');
                jQuery('.form-link a').click(function (e) {
                    e.preventDefault();
                    jQuery(target).addClass('fixed');
                    jQuery('body').addClass('body-freeze');
                    jQuery('html, body').animate({
                        scrollTop: target.offset().top
                    }, 500);
                });
                jQuery('#form-toggle-close').click(function () {
                    jQuery(target).removeClass('fixed');
                    jQuery('body').removeClass('body-freeze');
                });
            }
        };
        const stickyHeader = function () {
            const primaryHeader = document.querySelector('header');
            const body = document.body;
            const scrollWatcher = document.createElement('div');
            scrollWatcher.setAttribute('data-scroll-watcher', '');
            primaryHeader === null || primaryHeader === void 0 ? void 0 : primaryHeader.after(scrollWatcher);
            const navObserver = new IntersectionObserver((entries) => {
                body.classList.toggle('sticky-header', !entries[0].isIntersecting);
            });
            navObserver.observe(scrollWatcher);
        };
        // reset the nav menu and search when the screen size changes
        lqx.vars.window.on('screensizechange', () => {
            var _a, _b, _c;
            if (document.body.classList.contains('nav-menu-open')) {
                document.body.classList.remove('nav-menu-open');
                (_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.classList.remove('menu-open');
            }
            //close the careers form if it is open and the screen size changes
            if ((_b = document.querySelector('.panel-careers-page-form')) === null || _b === void 0 ? void 0 : _b.classList.contains('fixed')) {
                (_c = document.querySelector('.panel-careers-page-form')) === null || _c === void 0 ? void 0 : _c.classList.remove('fixed');
                document.body.classList.remove('body-freeze');
            }
        });
        return {
            init
            //Add other functions that need to be exposed
        };
    })();

    /**
     * patient_resources.dist.ts
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //Declare other variables as needed
    const patient_resources = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.patient_resources) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.patient_resources = {
                init: false
                //Add working variables as needed
            };
            // Default module configuration
            cfg.patient_resources = {
                enabled: true
                //Add default configuration as needed
            };
            if (customCfg)
                cfg.patient_resources = jQuery.extend(true, cfg.patient_resources, customCfg);
            // Initialize only if enabled
            if (cfg.patient_resources.enabled) {
                lqx.log('Initializing patient_resources');
                initAccordionListener();
            }
            // Run only once
            vars.patient_resources.init = true;
        };
        const initAccordionListener = function () {
            if (jQuery('.page-patient-resources').length) {
                jQuery('.page-patient-resources .mobile-accordion-control').on('click', function () {
                    const target = jQuery(this).closest('.lqx-block-accordion');
                    target.toggleClass('expanded');
                    if (target.hasClass('expanded')) {
                        jQuery(this).text('Show Less FAQs');
                    }
                    else {
                        jQuery(this).text('Show More FAQs');
                    }
                });
            }
        };
        return {
            init
            //Add other functions that need to be exposed
        };
    })();

    /**
     * module.dist.ts - my first module
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2018 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //Declare other variables as needed
    const team = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.team) === null || _a === void 0 ? void 0 : _a.init)
                return; // Change the module name
            vars.team = {
                init: false
                //Add working variables as needed
            };
            // Default module configuration
            cfg.team = {
                enabled: true
                //Add default configuration as needed
            };
            if (customCfg)
                cfg.team = jQuery.extend(true, cfg.team, customCfg);
            // Initialize only if enabled
            if (cfg.team.enabled) { // Change the module name
                lqx.log('Initializing module'); // Change the module name
                /**
                 *
                 * Place here logic that needs to be executed
                 * when the module is first initialized
                 *
                 */
            }
            // Run only once
            vars.team.init = true; // Change the module name
        };
        /**
         *
         * Add other functions, constants and variables as needed by the module
         *
         */
        const changeTeamLayout = function () {
            if (lqx.responsive.screen == 'xs') {
                let i = 0;
                const mainWrapper = '<div class="lqx-block-accordion container" data-open-on-load="n" data-open-multiple="n" data-browser-history="n"></div>';
                jQuery(mainWrapper).appendTo('article > .content');
                jQuery('.content > section:not(.lqx-block-hero)').each(function () {
                    //jQuery(this).removeClass('lqx-grid-6').addClass('lqx-grid-12');
                    let title = '';
                    switch (i) {
                        case 0:
                            title = 'Physician Leadership';
                            break;
                        case 1:
                            title = 'Physicians';
                            break;
                        case 2:
                            title = 'CRNAs';
                            break;
                        case 3:
                            title = 'Administrators';
                            break;
                    }
                    const wrapper = '<div class="accordion" id="team-accordion-' + i + '"><div class="accordion-item"><h3><button id="team-accordion-header-' + i + '" class="accordion-header" aria-expanded="false">' + title + '</button></h3><section id="team-accordion-panel-' + i + '" class="accordion-panel closed" role="region" aria-hidden="true"><div><span class="readmore" onclick="lqx.accordion.close(&quot;team-accordion-panel-' + i + '&quot;)">Close ' + title + '</span></div></section></div></div>';
                    jQuery(wrapper).appendTo('.lqx-block-accordion');
                    jQuery(this).prependTo('#team-accordion-' + i + ' .accordion-panel > div');
                    i++;
                });
            }
            else {
                if (jQuery('article >.content .lqx-block-accordion').length) {
                    jQuery('.accordion-panel > div > section:not(.lqx-block-hero)').each(function () {
                        jQuery(this).detach().appendTo('article > .content');
                    });
                    jQuery('.lqx-block-accordion').detach();
                }
            }
        };
        lqx.vars.window.on('screensizechange', () => {
            if (jQuery('.page-our-team').length)
                changeTeamLayout();
        });
        return {
            init
            //Add other functions that need to be exposed
        };
    })();

    /**
     * module.dist.ts - my first module
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //Declare other variables as needed
    const employment_form = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.employment_form) === null || _a === void 0 ? void 0 : _a.init)
                return; // Change the module name
            vars.employment_form = {
                init: false
                //Add working variables as needed
            };
            // Default module configuration
            cfg.employment_form = {
                enabled: true
                //Add default configuration as needed
            };
            if (customCfg)
                cfg.employment_form = jQuery.extend(true, cfg.employment_form, customCfg);
            // Initialize only if enabled
            if (cfg.employment_form.enabled) { // Change the module name
                lqx.log('Initializing employment_form'); // Change the module name
                /**
                 *
                 * Place here logic that needs to be executed
                 * when the module is first initialized
                 *
                 */
                jQuery(document).on('gform_post_render', function (event, formID) {
                    if (formID === 5) {
                        wrapGfPageSteps();
                        updateStepText();
                    }
                });
            }
            function wrapGfPageSteps() {
                jQuery('.gf_page_steps').wrap('<div class="lqx-page-steps-top"></div>');
                jQuery('.gf_page_steps').wrap('<div class="lqx-page-steps-wrapper"></div>');
                jQuery('.lqx-page-steps-wrapper').prepend('<div id="lqx-page-steps-progress"></div>');
                jQuery('.gform_required_legend').prependTo('.gform_body');
            }
            function updateStepText() {
                const currentPage = jQuery('.gf_step_active').index() + 1; // Get the current page number
                const totalPages = jQuery('.gf_step').length; // Get the total number of pages
                const stepLabelText = jQuery('.gf_step_active .gf_step_label').text();
                jQuery('#lqx-page-steps-progress').text('Page ' + currentPage + ' of ' + totalPages);
                jQuery('.lqx-page-steps-top').prepend('<h3 id="lqx-page-steps-label">' + stepLabelText + '</h3>');
            }
            // Run only once
            vars.employment_form.init = true; // Change the module name
        };
        /**
         *
         * Add other functions, constants and variables as needed by the module
         *
         */
        function checkValidation() {
            const currentPage = jQuery('.gf_step_active').index() + 1;
            if (jQuery('.gform_validation_errors').length) {
                //remove any existing messages
                //we only want to run this on the fifth and sixth page
                switch (currentPage) {
                    case 5:
                    case 6:
                        jQuery('#gform_page_5_' + currentPage + ' .required').each(function () {
                            const id = jQuery(this).attr('id').split('_')[2];
                            let validation = '';
                            // we need to process radio fields differently than the rest because the input functionality differs from other fields
                            if (jQuery(this).hasClass('gfield--type-radio')) {
                                const inputs = jQuery(this).find('input[type="radio"]');
                                let checked_input = false;
                                jQuery(inputs).each(function () {
                                    if (jQuery(this).is(':checked')) {
                                        checked_input = true;
                                    }
                                });
                                if (!checked_input) {
                                    validation = '<div id="validation_message_5_' + id + '" class="gfield_description validation_message gfield_validation_message">This field is required.</div>';
                                    jQuery(this).find('input, select, textarea').attr('aria-invalid', 'true');
                                }
                            }
                            else {
                                if (jQuery(this).find('input, select, textarea').val() !== '' && jQuery(this).find('input, select, textarea').val() !== null) {
                                    jQuery(this).removeClass('gfield_error');
                                    jQuery(this).find('input, select, textarea').attr('aria-invalid', 'false');
                                    //remove any existing validation message
                                    if (jQuery(this).find('#validation_message_5_' + id).length > 0) {
                                        jQuery(this).find('#validation_message_5_' + id).remove();
                                    }
                                }
                                else {
                                    jQuery(this).addClass('gfield_error');
                                    jQuery(this).find('input, select, textarea').attr('aria-invalid', 'true');
                                    //if this has a child field, make sure we check it instead
                                    const childFields = jQuery(this).find('input, select, textarea');
                                    if (childFields.length > 1) {
                                        if (jQuery(this).hasClass('gfield--type-name')) {
                                            validation = '<div id="validation_message_5_' + id + '" class="gfield_description validation_message gfield_validation_message">This field is required. Please ensure that at a minimum, the first and last name fields are filled in.</div>';
                                        }
                                        else if (jQuery(this).hasClass('gfield--type-address')) {
                                            validation = '<div id="validation_message_5_' + id + '" class="gfield_description validation_message gfield_validation_message">This field is required. Please ensure that all address fields are filled in.</div>';
                                        }
                                        else {
                                            validation = '<div id="validation_message_5_' + id + '" class="gfield_description validation_message gfield_validation_message">This field is required. Please make a selection.</div>';
                                        }
                                    }
                                    else {
                                        validation = '<div id="validation_message_5_' + id + '" class="gfield_description validation_message gfield_validation_message">This field is required.</div>';
                                        jQuery(this).find('input, select, textarea').attr('aria-invalid', 'true');
                                    }
                                }
                            }
                            if (jQuery(this).find('#validation_message_5_' + id).length == 0 && validation !== '') {
                                jQuery(this).append(validation);
                            }
                        });
                        break;
                }
            }
        }
        return {
            init,
            checkValidation
            //Add other functions that need to be exposed
        };
    })();

    /**
     * request-for-proposal.ts
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //Declare other variables as needed
    const request_for_proposal = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.request_for_proposal) === null || _a === void 0 ? void 0 : _a.init)
                return; // Change the module name
            vars.request_for_proposal = {
                init: false
                //Add working variables as needed
            };
            // Default module configuration
            cfg.request_for_proposal = {
                enabled: true
                //Add default configuration as needed
            };
            if (customCfg)
                cfg.request_for_proposal = jQuery.extend(true, cfg.request_for_proposal, customCfg);
            // Initialize only if enabled
            if (cfg.request_for_proposal.enabled) { // Change the module name
                lqx.log('Initializing module'); // Change the module name
                /**
                 *
                 * Place here logic that needs to be executed
                 * when the module is first initialized
                 *
                 */
                jQuery('a[href="#request-for-proposal"]').on('click', (e) => {
                    e.preventDefault();
                    lqx.lyqbox.open('request-for-proposal');
                });
            }
            // Run only once
            vars.request_for_proposal.init = true; // Change the module name
        };
        /**
         *
         * Add other functions, constants and variables as needed by the module
         *
         */
        return {
            init
            //Add other functions that need to be exposed
        };
    })();

    /**
     * scripts.ts - Main file for $lqx project scripts
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    // Declare other variables as needed
    const init = (customCfg) => {
        // Run only once
        if (vars.init)
            return;
        // Extend default config with custom config
        if (typeof customCfg !== 'object')
            customCfg = {};
        const mods = [
            'navigation',
            'team',
            'patient_resources',
            'employment_form',
            'request_for_proposal'
            //Add all the custom modules in the appropriate order for initialization
        ];
        console.log('Initializing scripts');
        lqx.log('Custom configuration', customCfg);
        // Initialize modules and pass extended config
        mods.forEach((mod) => {
            $lqx[mod].init(mod in customCfg ? customCfg[mod] : {});
        });
        // Trigger the $lqxready event
        lqx.vars.document.trigger('$lqxready');
        lqx.log('$lqxready Event');
        // Run only once
        vars.init = true;
    };
    // A ready utility function that works like jQuery(document).ready()
    const ready = (callback) => {
        if (vars.init === true) {
            callback();
        }
        else {
            vars.document.on('$lqxready', callback);
        }
    };
    const expObj = Object.defineProperties({
        init,
        ready,
        /* Modules */
        navigation,
        patient_resources,
        employment_form,
        team,
        request_for_proposal
    }, {
        // Set the cfg and vars properties as read-only
        cfg: {
            get() {
                return cfg;
            },
            set() {
                return undefined;
            }
        },
        vars: {
            get() {
                return vars;
            },
            set() {
                return undefined;
            }
        }
    });

    return expObj;

})();
